import React, { useState, useEffect } from 'react';
import { fetchVideoUrl } from '../../utils/TrainingHelpers';

const VideoPlayback = ({ selectedVideo, handleBackToCamera }) => {
    const [videoUrl, setVideoUrl] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadVideo = async () => {
            try {
                setError(null);
                const url = await fetchVideoUrl(selectedVideo.id);
                setVideoUrl(url);
            } catch (err) {
                console.error('Error fetching video URL:', err);
                setError('Failed to load video. Please try again.');
            }
        };

        if (selectedVideo?.id) {
            loadVideo();
        }

        // Cleanup function to reset state when component unmounts or video changes
        return () => {
            setVideoUrl(null);
            setError(null);
        };
    }, [selectedVideo?.id]);

    return (
        <div className="video-playback">
            {error ? (
                <div className="error-message">{error}</div>
            ) : videoUrl ? (
                <video 
                    key={videoUrl}
                    src={videoUrl} 
                    controls 
                    className="video-preview"
                    playsInline
                    autoPlay
                />
            ) : (
                <div className="loading-container">
                    <span>Loading video...</span>
                    <div className="loading-spinner">
                        <div className="spinner"></div>
                    </div>
                </div>
            )}
            <button onClick={handleBackToCamera} className="back-button">
                Back to Camera
            </button>
        </div>
    );
};

export default VideoPlayback;
